/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
* The SensorConsumptionRecord model module.
* @module model/SensorConsumptionRecord
* @version 2020-12-7
*/
export default class SensorConsumptionRecord {
    /**
    * Constructs a new <code>SensorConsumptionRecord</code>.
    * センサーによる消費量計測
    * @alias module:model/SensorConsumptionRecord
    * @class
    * @param timestamp {Number} 時刻
    * @param level {Number} 液面までの距離
    * @param oilVolume {Number} 灯油残量
    */

    constructor(timestamp, level, oilVolume) {
        
        
        this['timestamp'] = timestamp;
        this['level'] = level;
        this['oilVolume'] = oilVolume;
        
    }

    /**
    * Constructs a <code>SensorConsumptionRecord</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/SensorConsumptionRecord} obj Optional instance to populate.
    * @return {module:model/SensorConsumptionRecord} The populated <code>SensorConsumptionRecord</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SensorConsumptionRecord();
                        
            
            if (data.hasOwnProperty('timestamp')) {
                obj['timestamp'] = ApiClient.convertToType(data['timestamp'], 'Number');
            }
            if (data.hasOwnProperty('level')) {
                obj['level'] = ApiClient.convertToType(data['level'], 'Number');
            }
            if (data.hasOwnProperty('oilVolume')) {
                obj['oilVolume'] = ApiClient.convertToType(data['oilVolume'], 'Number');
            }
            if (data.hasOwnProperty('sensorId')) {
                obj['sensorId'] = ApiClient.convertToType(data['sensorId'], 'Number');
            }
            if (data.hasOwnProperty('serialNo')) {
                obj['serialNo'] = ApiClient.convertToType(data['serialNo'], 'String');
            }
        }
        return obj;
    }

    /**
    * 時刻
    * @member {Number} timestamp
    */
    'timestamp' = undefined;
    /**
    * 液面までの距離
    * @member {Number} level
    */
    'level' = undefined;
    /**
    * 灯油残量
    * @member {Number} oilVolume
    */
    'oilVolume' = undefined;
    /**
    * センサーID
    * @member {Number} sensorId
    */
    'sensorId' = undefined;
    /**
    * シリアルNo
    * @member {String} serialNo
    */
    'serialNo' = undefined;




}
